<div class="confirm-training-participation">
  <div class="confirm-training-participation-card">
    <div class="logo-image">
      <img src="assets/img/logo.jpg" alt="Logo" />
    </div>
    <h1 class="title">{{ 'CONFIRMATION.E-SIGNATURE' | translate }}</h1>
    <h2 class="subtitle">{{ training.name }}</h2>
    <div class="training-widget-value">
        <div *ngFor="let date of training.dates">
            <div class="training-dates-block-date">
                {{ training.dates[0] | trainingDate : translateService.currentLang }}
            </div>
            <div class="training-dates-block-time">
                <div *ngIf="translateService.currentLang == 'en'">
                    {{ training.dates[0].start | date : "hh:mm a" }} -
                    {{ training.dates[0].end | date : "hh:mm a" }}
                </div>
                <div *ngIf="translateService.currentLang == 'de'">
                    {{ training.dates[0].start | date : "HH:mm" }} -
                    {{ training.dates[0].end | date : "HH:mm" }} Uhr
                </div>
            </div>
        </div>
    </div>
     <app-panel>
        <p class="description">
            {{ 'CONFIRMATION.SIGNATURE-NOTE' | translate }}
        </p>

        <h2 class="subtitle-small">{{ 'CONFIRMATION.MY-PERSONAL-DATA' | translate }}:</h2>
    
        <div [formGroup]="form" class="form-container">
            <dx-text-box
                [placeholder]="('COMMON.FIELDS.EMAIL' | translate) + ' *'"
                formControlName="email"
                mode="email"
                [isValid]="email.valid || email.pristine"
                class="form-field"
            ></dx-text-box>

            <dx-text-box
                [placeholder]="('COMMON.FIELDS.FIRST-NAME' | translate) + ' *'"
                formControlName="firstName"
                [isValid]="firstName.valid || firstName.pristine"
                class="form-field"
            ></dx-text-box>

            <dx-text-box
                [placeholder]="('COMMON.FIELDS.LAST-NAME' | translate) + ' *'"
                formControlName="lastName"
                [isValid]="lastName.valid || lastName.pristine"
                class="form-field"
            ></dx-text-box>

            <div class="signature-container" [class.invalid]="!isSignatureValid && isFinished">
                <canvas #canvas class="signature-canvas" width="400" height="200"></canvas>
                <div *ngIf="showPlaceholder" class="placeholder-text">{{ 'CONFIRMATION.SIGN-HERE' | translate }}</div>
            </div>
            <dx-button
                [hidden]="isSignatureEmpty"
                class="clear-button"
                [text]="'COMMON.CLEAR' | translate"
                stylingMode="text"
                (onClick)="clearSignature()"
            ></dx-button>

            <dx-check-box
                formControlName="accepted"
                [text]="'CONFIRMATION.SIGNATURE-CONSENT' | translate"
                class="checkbox"
            ></dx-check-box>

            <dx-button
                [text]="'COMMON.SUBMIT' | translate"
                color="primary"
                class="submit-button"
                (onClick)="confirm()"
                [disabled]="form.invalid || (isConfirmClicked && !isSignatureValid)"
            ></dx-button>
        </div>
    </app-panel>
  </div>
</div>

<app-confirm-training-participation-modal 
    [(showModal)]="isConfirmed" 
    [confirmationResultModel]="confirmationResultModel"
/>
